import classNames from 'classnames';
import * as React from 'react';
import { useState } from 'react';
import { useOnClickOutside } from '@tcl-argon-hooks/hooks';
import { CaretDown, ChevronLeft, ChevronRight } from '@tcl-boron-icons/icons';
import { formatMonthYear } from '@tcl-argon-utils/utils';
import { ReverseRangeIterator } from '@tcl-argon-utils/utils';
import { useMonthYearInputStyles } from './styles';
import { IconButton } from '@tcl-boron-prefabs/icon-button';

interface MonthYearInputProps {
  month: number;
  year: number;
  /** The earliest year to display in the year-picker */
  minYear: number;
  /** The latest year to display in the year-picker */
  maxYear: number;
  onClickPreviousMonth: () => void;
  onClickNextMonth: () => void;
  onClickYearSelection: () => void;
}

export const MonthYearInput: React.FC<MonthYearInputProps> = ({
  month,
  year,
  onClickPreviousMonth: handleClickPreviousMonth,
  onClickNextMonth: handleClickNextMonth,
  onClickYearSelection: handleClickYearSelection,
}) => {
  const classes = useMonthYearInputStyles();

  return (
    <div className={classes.root}>
      <div className={classes.monthYear} onClick={handleClickYearSelection}>
        {formatMonthYear(month, year)}
        <CaretDown className={classes.caret} height="10px" width="10px" />
      </div>
      <div className={classes.changeMonthContainer}>
        <IconButton
          Icon={ChevronLeft}
          ariaLabel="previous_month"
          name="previous_month"
          className={classes.changeMonthControl}
          onClick={handleClickPreviousMonth}
          small
        />
        <IconButton
          Icon={ChevronRight}
          ariaLabel="next_month"
          name="next_month"
          className={classes.changeMonthControl}
          onClick={handleClickNextMonth}
          small
        />
      </div>
    </div>
  );
};
